import { Component } from '@angular/core';

type TradingDashboardView = 'realized' | 'summary';

@Component({
  selector: 'app-trading-dashboard',
  templateUrl: './trading-dashboard.component.html',
  styleUrls: ['./trading-dashboard.component.css']
})
export class TradingDashboardComponent {
  activeView: TradingDashboardView = 'realized'; // default screen

  setView(view: TradingDashboardView): void {
    this.activeView = view;
  }
}
